<script>
  import { onMount } from "svelte";

  // Not secrets: an AdSense client/slot ID is always visible in the rendered
  // page's HTML, so it's a plain default here rather than a build-time env
  // var (which would need wiring into CI, unlike the Firebase config).
  const DEFAULT_CLIENT = "ca-pub-1504099680412723";
  const DEFAULT_SLOT = "7544814994";

  export let slot = DEFAULT_SLOT;
  export let format = "auto";
  export let style = "display:block";

  const client = DEFAULT_CLIENT;

  onMount(() => {
    if (!client || !slot) return;

    if (!window.__adsenseScriptLoaded) {
      window.__adsenseScriptLoaded = true;
      const script = document.createElement("script");
      script.async = true;
      script.crossOrigin = "anonymous";
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
      document.head.appendChild(script);
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error("AdSense push failed", err);
    }
  });
</script>

{#if client && slot}
  <ins
    class="adsbygoogle"
    {style}
    data-ad-client={client}
    data-ad-slot={slot}
    data-ad-format={format}
    data-full-width-responsive="true"
  ></ins>
{/if}
